import clsx from 'clsx';
import { AppHeader } from '../AppHeader';
import { MobileBottomNav } from '../MobileBottomNav';
import { useMobileKeyboardListener, useRouteInfo } from '../../hooks';

/**
 * AppHeaderReactWrapper is the main entry point for the React-based AppHeader.
 * It renders both the header and mobile menu components.
 *
 * State management is handled via Redux (appHeaderSlice), which allows any component
 * in the app to dispatch actions to control the header state.
 *
 * Usage:
 * - This component is rendered at the top of the application shell
 */
export function AppHeaderReactWrapper() {
    const { isActive } = useRouteInfo();
    const isOnDashboard = isActive(['/dashboard']);
    useMobileKeyboardListener();

    // MobileBottomNav must be rendered outside the transformed wrapper because CSS transforms
    // create a new containing block for fixed-position descendants. If MobileBottomNav (which uses
    // position: fixed; bottom: 0) is inside a transformed element, it will be positioned relative
    // to that element instead of the viewport.
    return (
        <>
            <div
                className={clsx(
                    'absolute',
                    'w-full',
                    'z-[3]',
                    'transform-gpu',
                    isOnDashboard && 'bg-slate-grey-100-alt',
                )}
            >
                <AppHeader />
            </div>
            <MobileBottomNav />
        </>
    );
}
